import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableSidePanels from './tableAppSidePanels';

export default {
  title: 'Side Panels / Featured Content',
  attributeName: 'sidePanels',
  helpText: 'The main panel can have side panels that feature one video with a bigger portrait poster. The side panels are placed at the left or right of the main panel, being 4 the maximum amount of side panels the UI can have and 2, the maximum panels per side (left or right). This section is optional and it’s a list of side panels.',
  fields: [
    {
      attributeName: 'sidePanels',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableSidePanels,
    },
    
  ],
};
